import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { PageFull } from '@/presentation/components/PageFull'
import bgImage from '../assets/bg.webp'

export function FrameLayout() {
  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined
    }

    const updateViewportWidth = () => {
      const viewport = window.visualViewport
      const width = viewport?.width ?? window.innerWidth
      const clamped = Math.min(width, window.innerWidth)
      document.documentElement.style.setProperty(
        '--visual-viewport-width',
        `${clamped}px`,
      )
    }

    updateViewportWidth()
    window.addEventListener('resize', updateViewportWidth)
    window.addEventListener('orientationchange', updateViewportWidth)
    const viewport = window.visualViewport
    if (viewport?.addEventListener) {
      viewport.addEventListener('resize', updateViewportWidth)
    } else if (viewport?.onresize !== undefined) {
      viewport.onresize = updateViewportWidth
    }

    return () => {
      window.removeEventListener('resize', updateViewportWidth)
      window.removeEventListener('orientationchange', updateViewportWidth)
      if (viewport?.removeEventListener) {
        viewport.removeEventListener('resize', updateViewportWidth)
      } else if (viewport) {
        viewport.onresize = null
      }
    }
  }, [])

  return (
    <div className='relative min-h-screen overflow-x-hidden overflow-y-visible bg-transparent'>
      <div
        data-testid='desktop-background'
        className='fixed inset-0 -z-10 overflow-hidden'
      >
        <img
          src={bgImage}
          className='h-full w-full object-cover'
          alt=''
          aria-hidden='true'
        />
      </div>

      <div className='relative z-10 flex min-h-screen justify-center py-0 min-w-0'>
        <PageFull className='min-h-screen'>
          <Outlet />
        </PageFull>
      </div>
    </div>
  )
}
